export default "__VITE_ASSET__CRx0g2bu__"